import React from 'react';
import Text from '../Base/Text/Text';
import { joinClasses } from '../../Utils/className.util';
import { Theme } from '../../Enums/Theme.enum';

// @ts-ignore
import styles from './Buttons.module.scss';
import Loading, { LoadingSize } from '../Loading';

interface LinkButtonProps {
	onClick?: () => void;
	href?: string;
	title: string;
	theme: Theme;
	className?: string;
	firstUpper?: boolean;
	disabled?: boolean;
	isLoading?: boolean;
}

export default function LinkButton(props: LinkButtonProps) {
	const {
		onClick,
		title,
		theme,
		href,
		className,
		firstUpper,
		disabled = false,
		isLoading = false,
	} = props;

	const handlePress = () => {
		if (disabled) {
			return;
		}
		onClick && onClick();
	};

	const classes = joinClasses([
		styles.linkButton,
		styles[theme],
		className,
		disabled ? styles.disabled : '',
	]);
	const content = (
		<Text
			className={styles.title}
			tx={title}
			inline={true}
			firstUpper={firstUpper}
		/>
	);

	if (isLoading) {
		return <Loading size={LoadingSize.SMALL} />;
	}

	if (href) {
		return (
			<a className={classes} href={href} target='_blank'>
				{content}
			</a>
		);
	}

	return (
		<div className={classes} onClick={handlePress}>
			{content}
		</div>
	);
}
